

const applyClassButton1 = document.getElementById("golfTab");
const applyClassButton2 = document.getElementById("sportsTab");
const applyClassButton3 = document.getElementById("lawnTab");
const applyClassButton4 = document.getElementById("horticultureTab");
const tab = document.getElementById("tab");

// Add click event listeners to the button for applying different classes
applyClassButton1.addEventListener("click", applyGolfClass);
applyClassButton2.addEventListener("click", applySportsClass);
applyClassButton3.addEventListener("click", applyLawnClass);
applyClassButton4.addEventListener("click", applyHorticultureClass);

// Function to apply the "golf" class to the tab element
function applyGolfClass() {
    // Remove any existing classes and add the "golf" class
    tab.classList.remove("sports");
    tab.classList.add("golf");
    tab.classList.remove("lawn");
    tab.classList.remove("horticulture");
}

// Function to apply the "sports" class to the tab element
function applySportsClass() {
    // Remove any existing classes and add the "sports" class
    tab.classList.remove("golf");
    tab.classList.add("sports");
    tab.classList.remove("lawn");
    tab.classList.remove("horticulture");
}

// Function to apply the "sports" class to the tab element
function applyLawnClass() {
  // Remove any existing classes and add the "sports" class
  tab.classList.remove("golf");
  tab.classList.remove("sports");
  tab.classList.remove("horticulture");
  tab.classList.add("lawn");
}

// Function to apply the "sports" class to the tab element
function applyHorticultureClass() {
  // Remove any existing classes and add the "sports" class
  tab.classList.remove("golf");
  tab.classList.remove("sports");
  tab.classList.remove("lawn");
  tab.classList.add("horticulture");
}